import { __assign, __awaiter, __generator } from "tslib";
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { atom } from 'jotai';
import { TokenManager } from '../utils/TokenManager';
import { getServices, getUserDetails } from './apiCalls';
import { profileAtom } from './profile';
import { servicesAtom } from './services';
var authInitialValue = {
    token: '',
    invalidToken: false,
    isAuthenticated: false,
};
var storage = createJSONStorage(function () { return sessionStorage; });
var storedValue = JSON.parse(sessionStorage.getItem('anx_oss_a') || 'null');
var authValue = {};
if (storedValue) {
    if (TokenManager.validateToken(storedValue.token)) {
        authValue = storedValue;
    }
}
export var authAtom = atomWithStorage('anx_oss_a', authValue, storage);
export var handleAuth = atom(function (get) { return get(authAtom); }, function (get, set, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var newProfile, newServices, profileResp, serviceResp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newProfile = get(profileAtom);
                newServices = get(servicesAtom);
                set(authAtom, payload);
                return [4, getUserDetails(payload.token)];
            case 1:
                profileResp = _a.sent();
                if (profileResp) {
                    newProfile = profileResp;
                }
                return [4, getServices(payload.token)];
            case 2:
                serviceResp = _a.sent();
                if (serviceResp) {
                    newServices.list = serviceResp;
                    newServices.currentService = serviceResp[0];
                }
                set(servicesAtom, __assign({}, newServices));
                set(profileAtom, newProfile);
                return [2];
        }
    });
}); });
